import Axios from 'axios';
import { AssociationUrl } from '../../config/properties';

function setUpdated(organizationId) {
  Axios.get(`${AssociationUrl}/setUpdated?orgId=${organizationId}`)
}

export default setUpdated;


// WEBPACK FOOTER //
// ./src/components/Associations/setUpdated.js